import request from '@/utils/request'

// 获取作业包列表
export function findBagList(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/findBagList',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 获取作业包详情
export function bagDetail(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/bagDetail',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 根据子作业id获取子作业详情
export function itemDetail(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/itemDetail',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 子作业详情-班级报告
export function classReport(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/classReport',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 根据子作业获取试题详情（句子、新课文、单词短语、口语素材、新笔试）
export function getMaterialByItemId(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/getMaterialByItemId',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 获取全班学生新单词作业作答详情
export function listWordPhraseAnswers(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/listWordPhraseAnswers',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 获取全班学生新单词作业作答详情
export function listReadingAnswers(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/listReadingAnswers',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 修改作业包
export function modifyHomeworkBag(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/modifyHomeworkBag',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 删除作业包
export function deleteHomeworkBag(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/deleteHomeworkBag',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 获取全班学生句子作业作答详情
export function listSentenceAnswers(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/listSentenceAnswers',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 获取全班学生口语素材作业作答详情
export function listSpokenMaterialAnswers(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/listSpokenMaterialAnswers',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 发送作业包的表扬、鼓励、催交消息通知
export function sentHomeworkBagNotice(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/sentHomeworkBagNotice',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 根据趣味配音id查询趣味配音试题详情
export function getBaseExerciseDetailForApp(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/dub/getBaseExerciseDetailForApp',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 获取全班学生口语素材作业作答详情
export function listVideoAnswers(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/listVideoAnswers',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 批量打回子作业
export function batchRedo(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/batchRedo',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 分页获取导出任务列表
export function pageList(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/exportTask/pageList',
      method: 'post',
      data
    },
    'teacher-api'
  )
}

// 导出作业包统计到Excel
export function exportStudentStatistics(data) {
  return request(
    {
      url: '/apiv2/primaryTeacher/homework/exportStudentStatistics',
      method: 'post',
      data
    },
    'teacher-api'
  )
}
